module.exports = __webpack_public_path__ + "static/media/IMG_2217.99962280.JPG";